import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Menu, MenuItem } from '@mui/material';
import MDButton from 'components/MDButton';

import FileDownload from '@mui/icons-material/FileDownload';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const DownloadMenu = ({ onDownloadCSVClick, onDownloadXLSXClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <MDButton
        sx={{ minHeight: 48 }}
        color="info"
        id="demo-customized-button"
        aria-controls={`open` ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        startIcon={<FileDownload />}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Export to
      </MDButton>
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            onDownloadCSVClick();
            handleClose();
          }}
          disableRipple
        >
          CSV
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDownloadXLSXClick();
            handleClose();
          }}
          disableRipple
        >
          XLSX
        </MenuItem>
      </Menu>
    </>
  );
};

DownloadMenu.propTypes = {
  onDownloadCSVClick: PropTypes.func,
  onDownloadXLSXClick: PropTypes.func,
};

DownloadMenu.defaultProps = {
  onDownloadCSVClick: () => {},
  onDownloadXLSXClick: () => {},
};

export default DownloadMenu;
